import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import verificareToken from './VerificareToken';
import { CircularProgress } from '@mui/material';

const Dosar = () => {
  const [searchParams] = useSearchParams();
  const { token } = verificareToken();

  useEffect(() => {
    const userId = searchParams.get('userId');
    const numarDosar = searchParams.get('numarDosar');

    if (!userId || !numarDosar) {
      window.location.href = `/lista-dosare`;
      return;
    }

    const fetchDosar = async () => {
      try {
        const apiUrl = window.API_URL;
        const response = await fetch(
          `${apiUrl}getDosarByUserIdAndNumarDosar?userId=${encodeURIComponent(userId)}&numarDosar=${encodeURIComponent(numarDosar)}`,
          {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        );

        if (!response.ok) {
          throw new Error('Nu s-a putut obține dosarul.');
        }

        const data = await response.json();
        const idDosar = data?.data?.dosar?.id;

        if (idDosar) {
          window.location.href = `/editare-dosar/${idDosar}`;
        } else {
          window.location.href = `/lista-dosare`;
        }
      } catch (err) {
        console.error(err);
        window.location.href = `/lista-dosare`;
      }
    };

    fetchDosar();
  }, [searchParams, token]);

  return (
    <div className="card container mx-auto p-5 mt-5" style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '10vh',
      width: '100% !important' 
      }}> 
      <CircularProgress />
      </div>
  );
};

export default Dosar;
